import React, { useState } from "react";
import { Chip, TabsTemplate } from "UiKit";
import { TABS } from "../innerPanel.const";
import { Divider } from "Components/Divider";
import TabMethods from "./tabMethods";
import TabScripts from "./tabScripts";
import styles from "./InnerPanelTabs.module.css";
export default function InnerPanelTabs({ tabAttribute, panelId }) {
    const [selected, setSelected] = useState(TABS[0]);
    const tabRender = () => {
        switch (selected.key) {
            case "ATTRIBUTES":
                return tabAttribute;
            case "METHODS":
                return React.createElement(TabMethods, null);
            case "SCRIPTS":
                return React.createElement(TabScripts, { panelId: panelId });
            default:
                return null;
        }
    };
    return (React.createElement("div", { className: styles.container },
        React.createElement(Divider, null),
        React.createElement(TabsTemplate, { itemRender: ({ data, isActive }) => (React.createElement(Chip, { styleType: isActive ? "input-selected" : "input", size: "md", isActive: isActive, className: styles.tab },
                React.createElement("span", null, data.label))), selectedItem: selected, onClickItem: setSelected, getId: tab => tab.key, items: TABS, direction: "row", classNameContainer: styles.tabs }),
        React.createElement(Divider, null),
        React.createElement("div", { className: styles.content }, tabRender())));
}
